<div class="d-flex position-relative" [ngClass]="actualClass">
  <div class="d-flex w-100">
    <span class="suffixDiv" #invisibleSuffixElement *ngIf="suffix && !numericInput">{{suffix}}</span>
    <input
      [placeholder]="placeholder"
      *ngIf="!numericInput && !isTextArea"
      class="inlineBox"
      [tabIndex]="(readonly$ | async) ? '-1' : null"
      #inputElementReference
      [readOnly]="(readonly$ | async) "
      (keyup.enter)="writeIdentifierInForm()"
      (keyup.escape)="setToReadonly()"
      kendoTextBox
      [disabled]="isDisabled"
      (ngModelChange)="inputFieldValueChange($event)"
      [(ngModel)]="inputFieldValue"
      (blur)="handleOnTouched()"
      (input)="handleOnTouched()">
    <textarea
      [placeholder]="placeholder"
      *ngIf="!numericInput && isTextArea"
      class="inlineBox"
      (valueChange)="checkForScrollbar()"
      [ngClass]="{'auto-height': readonly$ | async}"
      [tabIndex]="(readonly$ | async) ? '-1' : null"
      #inputElementReference
      [readOnly]="(readonly$ | async) "
      (keyup.escape)="setToReadonly()"
      kendoTextArea
      [disabled]="isDisabled"
      (ngModelChange)="inputFieldValueChange($event)"
      [(ngModel)]="inputFieldValue"
      (blur)="handleOnTouched()"
      (input)="handleOnTouched()"></textarea>
    <kendo-numerictextbox
      *ngIf="numericInput"
      class="inlineBox"
      [spinners]="false"
      [tabIndex]="(readonly$ | async) ? -1 : null"
      #inputElementReference
      [readonly]="(readonly$ | async) "
      [decimals]="0"
      [rangeValidation]="true"
      (keyup.enter)="writeIdentifierInForm()"
      (keyup.escape)="setToReadonly()"
      [disabled]="isDisabled"
      (ngModelChange)="inputFieldValueChange($event)"
      [format]="(readonly$ | async) ? '########.#### \'' + suffix + '\'' : '########.####'"
      [(ngModel)]="inputFieldValue"
      (blur)="handleOnTouched()"
      (input)="handleOnTouched()"></kendo-numerictextbox>
    <ng-container *ngIf="!(readonly$ | async)">
      <ng-container *ngTemplateOutlet="addition"></ng-container>
    </ng-container>

  </div>

  <div class="staticIconWrapper" [ngClass]="{'scrollbarIsVisible': scrollbarIsVisible}" *ngIf="loadingIndicator">
    <qpoint-icon [pulse]="true" icon="spinner"
                 (click)="toggleReadOnly()"></qpoint-icon>
  </div>
  <div class="staticIconWrapper" [ngClass]="{'scrollbarIsVisible': scrollbarIsVisible}"
       *ngIf="(readonly$ | async) && !loadingIndicator && !editDisabled">
    <qpoint-icon icon="pencil-alt"
                 (click)="toggleReadOnly()"></qpoint-icon>
  </div>
</div>
<qpoint-validation-message [controlToValidate]="controlForValidation" [isSubmitted]="controlForValidationDisplayActive"></qpoint-validation-message>
<div class="d-flex infoMessageOnEdit"
     *ngIf="(activeInlineEditingInternal$ | async) && !(readonly$ | async)  && infoMessageOnEdit">
  <div class="inlineEditingTextIcon">
    <qpoint-icon iconType="material-outlined" icon="info"></qpoint-icon>
  </div>
  <div>
    <span [innerHTML]="infoMessageOnEdit | translate"></span>
  </div>
</div>

<div class="d-flex flex-row justify-content-end" style="margin-top: 5px"
     *ngIf="!(readonly$ | async)  && (activeInlineEditingInternal$ | async)">
  <div class="d-flex">
    <qpoint-button icon="times" [variant]="ButtonVariant.icon"
                   (buttonClicked)="setToReadonly()">

    </qpoint-button>
  </div>
  <div class="d-flex">
    <qpoint-button [variant]="ButtonVariant.icon" icon="check"
                   (buttonClicked)="writeIdentifierInForm()"></qpoint-button>
  </div>
</div>
